module.exports = __webpack_public_path__ + "b11c217bf87b1260fb8bd89c2bceeeb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_alpha_gray.png
// module id = 59
// module chunks = 0 1 2 3 4